// extracted by mini-css-extract-plugin
module.exports = {"emoji-section__title":"EmojiSection_emoji-section__title__XkSoT","emoji-section__list":"EmojiSection_emoji-section__list__35PSe"};